import React, { useState, useEffect } from 'react';
import ChatWindow from './components/ChatWindow';
import InputArea from './components/InputArea';
import axios from 'axios';
import './App.css';

function App() {
  const [messages, setMessages] = useState([]);

  // Adding an introductory message when the component mounts
  useEffect(() => {
    const welcomeMessagePart1 = {
      type: 'bot',
      text: `Welcome to the Chatbot API! This chatbot can assist you with various queries. 
      It's capable of fetching movie data, generating responses based on movie details.`
    };

    const welcomeMessagePart2 = {
      type: 'bot',
      text: `Here are some prompts you can try:
      - "Tell me about the movie Inception."
      - "Can you recommend some science fiction movies?"
      - "I need a summary of the plot for The Matrix."
      `
    };

    setMessages([welcomeMessagePart1, welcomeMessagePart2]); // This will set the initial messages in the chat window
  }, []);

  const sendMessage = async (text) => {
    const userMessage = { type: 'user', text };
    setMessages(messages => [...messages, userMessage]);

    try {
      const response = await axios.post('https://oriolarnedo.pythonanywhere.com/api/message', {query: text});
      const botMessages = response.data.answer;
      if (Array.isArray(botMessages)) {
        setMessages(messages => [...messages, ...botMessages.map(text => ({type: 'bot', text}))]);
      } else {
        const botMessage = {type: 'bot', text: botMessages};
        setMessages(messages => [...messages, botMessage]);
      }
    } catch (error) {
      console.error('error sending message:', error);
      const errorMessage = {type: 'error', text: 'Failed to connect to the server.'};
      setMessages(messages => [...messages, errorMessage]);
    }
  };

  return (
    <div className="App">
      <ChatWindow messages={messages} />
      <InputArea onSend={sendMessage} />
    </div>
  );
}

export default App;
